export const IsSSR = () => {
	if (typeof window !== 'undefined') return false;
	else return true;
};